import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import { PrimeNGConfig } from 'primeng/api';
import * as XLSX from 'xlsx';
import {Contact, ContactService} from '@app/_components/contact';

@Component({
    selector: 'app-import-data',
    templateUrl: './import-data.component.html',
    styleUrls: ['./import-data.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ImportDataComponent implements OnInit {
	private tagsSelected: any;
	willDownload: boolean;
	private excelContacts: any = [];
  	private jsonArrayRaw: any;
	sampleFileLink: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private contactService: ContactService ,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title;
		this.tagSourceForImport = data.tagsourceForInput;
		this.sampleFileLink = data.sampleFileLink;

	}

	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
	@Output() dataAndTagsSelected = new EventEmitter<any>();

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;
  @Input() tagSourceForImport: any;

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

	}


	formAdd() {
		try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      console.log('property-add post: ' + JSON.stringify(this.form1.value));
      this.formLoading = true;
      if (!this.tagsSelected) {
        this.tagsSelected = [];
      }
      this.form1.value.tags = this.tagsSelected;
      const datas: any[] = [];

      if (this.excelContacts != null) {
        this.excelContacts.forEach(email => {
          datas.push(email);
        });
      }

      this.form1.value.dataAPIList = datas;
      this.form1.value.tagJoinAPIList = this.tagsSelected;
      let fullData = {
        tagJoinAPIList: undefined,
        jsonArrayRaw: undefined
      };
      fullData.tagJoinAPIList = this.tagsSelected;
      fullData.jsonArrayRaw = this.jsonArrayRaw;
      this.dataAndTagsSelected.emit(fullData);
    }
    catch (error) {
      this.alertService.error(error);
    }
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			importMails: [],
		});
	}

	updateTagSelected($event: any) {
		this.tagsSelected = $event;
	}
	onFileChange(ev) {
		let workBook = null;
		let jsonData = null;
		const reader = new FileReader();
		const file = ev.target.files[0];
		reader.onload = (event) => {
			const data = reader.result;
			workBook = XLSX.read(data, { type: 'binary' });
			jsonData = workBook.SheetNames.reduce((initial, name) => {
				const sheet = workBook.Sheets[name];
				initial[name] = XLSX.utils.sheet_to_json(sheet);
				return initial;
			}, {});
      		this.jsonArrayRaw = jsonData.data;
			const dataString = JSON.stringify(jsonData);
			document.getElementById('output').innerHTML = jsonData.data.length + ' records selected';
			this.setDownload(dataString);
		};
		reader.readAsBinaryString(file);
	}
	setDownload(data) {
		this.willDownload = true;
		setTimeout(() => {
			const el = document.querySelector("#download");
			el.setAttribute("href", `data:text/json;charset=utf-8,${encodeURIComponent(data)}`);
			el.setAttribute("download", 'xlsxtojson.json');
		}, 1000);
	}
}
